import React from 'react';
import { IssueItem } from '../../models/issueItem';

interface IssueDetailSectionProps {
  issue: IssueItem;
}

const IssueDetailSection: React.FC<IssueDetailSectionProps> = ({ issue }) => {
  return (
    <div className="w-full p-4">
      <h2 className="text-xl font-semibold mb-2">Issue Details</h2>
      <div className="grid grid-cols-1 gap-4">
        {Object.entries(issue).map(([key, value]) => {
          if (key === 'title' || key === 'count' || key === 'ID' || key === 'index') {
            return null;
          }
          return (
            <div key={key} className="flex flex-col">
              <span className="font-semibold capitalize">{key.replace(/_/g, ' ')}:</span>
              <span>{value?.toString()}</span>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default IssueDetailSection;
